import React from "react";
import { WarningCircle, ArrowClockwise } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

/** Route-level error boundary — keeps the app shell alive when a page
 *  throws, and offers retry (re-mount) / reload without losing session. */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Page crashed:", error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        className="flex flex-col items-center justify-center text-center py-24 px-4"
        role="alert"
        data-testid="page-error"
      >
        <div className="h-12 w-12 rounded-full bg-destructive/10 text-destructive flex items-center justify-center mb-4">
          <WarningCircle size={28} weight="duotone" />
        </div>
        <h2 className="font-display text-xl font-medium mb-1">Something went wrong on this page</h2>
        <p className="text-sm text-muted-foreground max-w-md mb-6">
          The rest of the app is fine — you can retry this page, or go back and
          continue working. If it keeps happening, note what you clicked and
          check the audit trail.
        </p>
        <div className="flex items-center gap-3">
          <Button onClick={this.reset} data-testid="page-error-retry">
            <ArrowClockwise size={16} className="mr-2" /> Try again
          </Button>
          <Button variant="outline" onClick={() => window.location.reload()}>
            Reload app
          </Button>
        </div>
      </div>
    );
  }
}
